import {
  Clock,
  User,
  FileType,
  MessageSquare,
  Calendar,
  FileText,
} from "lucide-react";

const PendingRequestsTab = ({
  t,
  styles,
  screenSize,
  pendingRequests,
  isLoading,
  language,
  canProcessDocuments,
  onProcessClick,
}) => {
  if (isLoading) {
    return (
      <div style={styles.emptyState}>
        <Clock
          size={screenSize.isMobile ? 48 : 64}
          style={{ marginBottom: "20px", opacity: 0.3 }}
        />
        <h3 style={styles.emptyStateTitle}>{t.loading}</h3>
      </div>
    );
  }

  if (pendingRequests.length === 0) {
    return (
      <div style={styles.emptyState}>
        <Clock
          size={screenSize.isMobile ? 48 : 64}
          style={{ marginBottom: "20px", opacity: 0.3 }}
        />
        <h3 style={styles.emptyStateTitle}>{t.noPendingRequests}</h3>
        <p style={styles.emptyStateDesc}>{t.noPendingDesc}</p>
      </div>
    );
  }

  return (
    <>
      {pendingRequests.map((request) => (
        <div key={request.id} style={styles.requestCard}>
          <div style={styles.requestHeader}>
            <div style={styles.requestInfo}>
              <h4 style={styles.employeeName}>
                <User size={screenSize.isMobile ? 16 : 18} />
                {request.employee?.sr || t.unknownEmployee}
              </h4>

              <p style={styles.requestDetail}>
                <span style={styles.detailLabel}>
                  <FileType size={14} />
                  {t.type}:
                </span>
                <span style={styles.badge}>
                  {request.requestType?.startsWith("upload:")
                    ? `📤 ${request.requestType.replace("upload:", "")}`
                    : request.requestType}
                </span>
              </p>

              {request.recipient &&
                !request.requestType?.startsWith("upload:") && (
                  <p style={styles.requestDetail}>
                    <span style={styles.detailLabel}>
                      <User size={14} />
                      {t.recipient}:
                    </span>
                    {request.recipient}
                  </p>
                )}

              <p style={styles.requestDetail}>
                <span style={styles.detailLabel}>
                  <MessageSquare size={14} />
                  {t.reason}:
                </span>
                {request.reason || t.notAvailable}
              </p>

              {request.workflowProgress && (
                <p style={styles.requestDetail}>
                  <span style={styles.detailLabel}>
                    <Clock size={14} />
                    {language === "ar" ? "مسار العمل:" : "Workflow:"}
                  </span>
                  <span style={{
                    fontWeight: "500",
                    color: request.currentUserCanAct ? "#e28743" : "#64748b",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    flexDirection: language === "ar" ? "row-reverse" : "row"
                  }}>
                    {request.workflowProgress.currentStepName} ({language === "ar" ? "خطوة" : "Step"} {request.workflowProgress.currentActiveStepIndex} {language === "ar" ? "من" : "of"} {request.workflowProgress.totalSteps})
                    {request.currentUserCanAct && (
                      <span style={{
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "11px",
                        background: "#fef3c7",
                        color: "#d97706",
                        fontWeight: "600"
                      }}>
                        {language === "ar" ? "مطلوب اتخاذ إجراء" : "Action Required"}
                      </span>
                    )}
                  </span>
                </p>
              )}

              <p style={styles.requestDetail}>
                <span style={styles.detailLabel}>
                  <Calendar size={14} />
                  {t.requestDate}:
                </span>
                {new Date(
                  request.requestedDate || request.created_at
                ).toLocaleDateString(language === "ar" ? "ar-EG" : "en-US")}
              </p>
            </div>

            {canProcessDocuments && (
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: screenSize.isMobile ? "stretch" : "flex-end",
                gap: "6px",
                width: screenSize.isMobile ? "100%" : "auto"
              }}>
                <button
                  style={styles.button}
                  onClick={() => onProcessClick(request)}
                  disabled={isLoading || (!!request.workflowInstanceId && request.currentUserCanAct === false)}
                >
                  <FileText size={screenSize.isMobile ? 14 : 16} />
                  {t.processRequest}
                </button>
                {!!request.workflowInstanceId && request.currentUserCanAct === false && (
                  <span style={{ 
                    fontSize: "12px", 
                    opacity: 0.8, 
                    color: "#94a3b8",
                    textAlign: language === "ar" ? "right" : "left"
                  }}>
                    {language === "ar" ? "بانتظار موافقة المسؤول الحالي" : "Awaiting current actor approval"}
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default PendingRequestsTab;